var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtaIconsAddNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.25,
    height: 17.875,
    viewBox: "0 0 21.25 17.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-55.75 -17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.719-3.5H0v-7.219a.655.655,0,0,0-.656-.656H-11.594a.655.655,0,0,0-.656.656V.219a.655.655,0,0,0,.656.656h7.219V-2.844A.658.658,0,0,1-3.719-3.5ZM-.191-2A.654.654,0,0,0,0-2.458v-.167H-3.5v3.5h.164A.656.656,0,0,0-2.871.684Z",
    transform: "translate(68 34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(65 17)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.25-3.5H-2.5V-5.75A.25.25,0,0,0-2.75-6h-.5a.25.25,0,0,0-.25.25V-3.5H-5.75A.25.25,0,0,0-6-3.25v.5a.25.25,0,0,0,.25.25H-3.5V-.25A.25.25,0,0,0-3.25,0h.5A.25.25,0,0,0-2.5-.25V-2.5H-.25A.25.25,0,0,0,0-2.75v-.5A.25.25,0,0,0-.25-3.5Z",
    transform: "translate(74 26)",
    fill: "#3f6fbc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaIconsAddNotes);
export default __webpack_public_path__ + "static/media/ctaIcons_AddNotes.bc3b870cc41cd7bb52028302ea1e7cc3.svg";
export { ForwardRef as ReactComponent };